import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

const displayCategories = categories.filter((c) => c.slug !== 'all');

const categoryImages: Record<string, string> = {
  plush: 'https://readdy.ai/api/search-image?query=A%20cute%20collection%20of%20soft%20pastel%20plush%20rabbit%20toys%20in%20various%20sizes%20arranged%20on%20a%20fluffy%20white%20surface%2C%20pink%20and%20cream%20colors%2C%20kawaii%20style%2C%20soft%20warm%20lighting%2C%20minimal%20aesthetic&width=600&height=400&seq=cat-plush-01&orientation=landscape',
  merch: 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20cute%20rabbit%20themed%20accessories%20including%20stickers%20badges%20and%20stationery%2C%20pastel%20pink%20color%20scheme%2C%20organized%20neatly%20on%20white%20surface%2C%20kawaii%20style%2C%20soft%20lighting&width=600&height=400&seq=cat-merch-01&orientation=landscape',
  collab: 'https://readdy.ai/api/search-image?query=A%20creative%20display%20of%20rabbit%20collaboration%20products%20with%20art%20prints%20and%20fashion%20items%2C%20mint%20green%20and%20pink%20color%20palette%2C%20artistic%20layout%2C%20kawaii%20style%2C%20soft%20lighting&width=600&height=400&seq=cat-collab-01&orientation=landscape',
  giftbox: 'https://readdy.ai/api/search-image?query=A%20beautiful%20pastel%20pink%20gift%20box%20tied%20with%20cream%20ribbon%2C%20surrounded%20by%20small%20cute%20rabbit%20accessories%20and%20dried%20flowers%2C%20soft%20warm%20lighting%2C%20luxury%20kawaii%20aesthetic&width=600&height=400&seq=cat-gift-01&orientation=landscape',
};

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-secondary-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-accent-500 tracking-widest mb-2">
            ✦ CATEGORIES ✦
          </p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            产品分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            探索嫩小兔的萌趣产品线，找到你的专属萌物
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to="/category"
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-[3/4]"
            >
              <img
                src={categoryImages[cat.slug] || categoryImages.plush}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <i className={`${cat.icon} text-white/80 text-lg`}></i>
                  <h3 className="font-heading text-lg md:text-xl text-white">{cat.name}</h3>
                </div>
                <span className="inline-flex items-center gap-1 text-xs text-white/70 font-medium whitespace-nowrap">
                  探索更多
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}